import React from 'react';
import RelativeResultList from './RelativeResultList';
//import ResultTList from './ResultTList';
//import ResultTList from './ResultTList';
//import { Tab, Tabs/*, TabList, TabPanel*/ } from 'react-tabs';
//import '../../css/react-tabs2.css';
//import Tabs from 'react-bootstrap/Tabs'
//import Tab from 'react-bootstrap/Tab'

// import '../../css/bootstrap.min.css';
// import '../../css/bootstrap-rtl.min.css';
// import '../../css/bootstrap-grid.min.css';
// //import '../../css/jquery-ui.min.css';
// import '../../css/keyboard.min.css';
// import '../../font/dana/fontiran.css';
// import '../../font/dana/style.css';
// import '../../css/menu.css';
// import '../../css/style.css';

class RelativeSearchResult extends React.Component {
    state = { statments : [] }
    state = { prevwordnext : '' }

    constructor(props) {
        super(props);
        //this.state = { statments: this.props.statments };
        this.state = { results: this.props.results };
        //this.state = { t_results: this.props.t_results };
        //this.state = { prevwordnext: this.props.prevwordnext };
    }
    
    render() {
        return (
            <div className="container-fluid" id="words_search_results">
                <div className="container">
                    <div className="alert" role="alert">
                        {this.props.pageData.length!==0 && this.props.pageData[0].F29904!== undefined?this.props.pageData[0].F29904:29904/*"برای مشاهده برچسب‌های واژه روی شماره کلیک کنید"*/}
                    </div>

                    <RelativeResultList     results={this.props.results}
                        pageData={this.props.pageData}
                    />
                </div>
            </div>
         )
     }
 }

export default RelativeSearchResult;